// extracted by mini-css-extract-plugin
export default {"wrapper":"EdgeGradient_wrapper__fm5Vq","content":"EdgeGradient_content__trY5Q","edgegradient":"EdgeGradient_edgegradient__FLr1i"};